import React, { useEffect, useState } from 'react';
import { pageTitle } from '../../helper';
import 'swiper/css';
import 'swiper/css/pagination';
import Hero6 from '../Hero/Hero6';
import Spacing from '../Spacing';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import NowShowingSlider from '../Slider/NowShowingSlider';
import UpcomingSlider from '../Slider/UpcomingSlider';
import MovingText from '../MovingText';
import Card from '../Card';
import IconBox from '../IconBox';
import GalleryStyle2 from '../Gallery/GalleryStyle2';
import LogoList from '../LogoList';
import TestimonialSliderStyle3 from '../Slider/TestimonialSliderStyle3';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import Cta from '../Cta';
import { getHeroSlides, getNowShowingMovies, getUpcomingMovies } from '../../api/movieApi';

const heroSocialLinks = [
  { name: 'Facebook', links: '/' },
  { name: 'Twitter', links: '/' },
];

export default function ShowcasePortfolioHome() {
  pageTitle('Showcase Portfolio');

  const [heroSlides, setHeroSlides] = useState([]);
  const [nowShowingMovies, setNowShowingMovies] = useState([]);
  const [upcomingMovies, setUpcomingMovies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let isMounted = true;

    async function loadHomepageData() {
      try {
        const [hero, nowShowing, upcoming] = await Promise.all([
          getHeroSlides(),
          getNowShowingMovies(),
          getUpcomingMovies(),
        ]);

        if (!isMounted) return;
        setHeroSlides(hero);
        setNowShowingMovies(nowShowing);
        setUpcomingMovies(upcoming);
      } catch (err) {
        console.error('Failed to load homepage data:', err.message);
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    loadHomepageData();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      {heroSlides.length > 0 && (
        <Hero6
          heroSocialLinks={heroSocialLinks}
          socialLinksHeading="Follow Us"
          showcaseData={heroSlides}
        />
      )}

      {/* Start Now Showing Section */}
      <Spacing lg="145" md="80" />
      <Div className="container">
        <SectionHeading title="Now Showing <br/>Movies" subtitle="" variant="cs-style1" />
        <Spacing lg="85" md="45" />
        {loading ? (
          <p style={{ color: "#999" }}>Loading...</p>
        ) : (
          <NowShowingSlider movies={nowShowingMovies} />
        )}
      </Div>
      <Spacing lg="150" md="80" />
      {/* End Now Showing Section */}

      {/* Start MovingText Section */}
      <Spacing lg="125" md="70" />
      <MovingText text="Experience Cinema Like Never Before." />
      <Spacing lg="105" md="70" />
      {/* End MovingText Section */}

      {/* Start Upcoming Section */}
      <Spacing lg="150" md="80" />
      <Div className="cs-shape_wrap_4">
        <Div className="cs-shape_4"></Div>
        <Div className="cs-shape_4"></Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading title="UpComing movies" subtitle="" btnText="Notify Me" btnLink="/blog" />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-7 offset-xl-1">
              <Div className="cs-half_of_full_width">
                {loading ? (
                  <p style={{ color: "#999" }}>Loading...</p>
                ) : (
                  <UpcomingSlider movies={upcomingMovies} />
                )}
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      <Spacing lg="30" md="30" />
      {/* End Upcoming Section */}
      <Spacing lg="30" md="30" />
      {/* Start Why Choose Section */}
      <Spacing lg="100" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-xl-5 col-lg-6">
            <Div className="cs-image_layer cs-style1">
              <Div className="cs-image_layer_in">
                <img src="/images/img/image_7.webp" alt="About" className="w-100 cs-radius_15" />
              </Div>
            </Div>
            <Spacing lg="0" md="40" />
          </Div>
          <Div className="col-xl-5 offset-xl-1 col-lg-6">
            <SectionHeading
              title="Every show is a story. Every visit is a celebration."
              subtitle=" Koraput's Ultimate Entertainment Hub"
            >
              <Spacing lg="30" md="20" />
              <p className="cs-m0">
                Choose from the latest Bollywood blockbusters, Hollywood hits, and regional films,
                all screening across our 4 premium screens equipped with Dolby surround sound and
                crystal-clear projection.
              </p>
              <Spacing lg="15" md="15" />
              <p className="cs-m0">
                Unwind at our modern cafeteria, take a thrilling break in our massive gaming zone,
                and treat your taste buds at our outdoor food court offering everything from local
                snacks to global cuisine.
              </p>
              <Spacing lg="30" md="30" />
              <Div className="cs-separator cs-accent_bg"></Div>
              <Spacing lg="25" md="0" />
            </SectionHeading>
          </Div>
        </Div>
      </Div>
      {/* End Why Choose Section */}

      {/* Start Service Section */}
      <Spacing lg="150" md="80" />
      <Div id="service">
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title="In the darkness of a theater, stories shine the brightest."
                subtitle=""
                btnText="Explore the Multiplex"
                btnLink="/service"
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-8">
              <Div className="row">
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card title="Game Zone " link="/service/service-details" src="/images/img/image_37.webp" alt="Service" />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card title="Food Court " link="/service/service-details" src="/images/img/image_1.webp" alt="Service" />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card title="MOVIE ZONE" link="/service/service-details" src="/images/img/image_6.webp" alt="Service" />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card title="Big Screens" link="/service/service-details" src="/images/img/image_14.webp" alt="Service" />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      {/* End Service Section */}

      <Spacing lg="145" md="80" />
      <Div className="container">
        <SectionHeading title="Unwind, indulge, and escape—under one roof." subtitle="" variant="cs-style1 text-center" />
        <Spacing lg="90" md="45" />
        <Div className="row">
          <Div className="col-lg-4">
            <IconBox
              icon="/images/icons/service_icon_1.svg"
              title='Movie Zone"'
              subtitle=" Secure your seats instantly at MeghrazCinemaz, Koraput. Book movie tickets online for the latest Bollywood, Hollywood, and regional films"
            />
            <Spacing lg="30" md="30" />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon="/images/icons/service_icon_2.svg"
              title="Game Zone"
              subtitle="Our arcade machines, high-end video games will keep you entertained for hours. From racing simulators to claw machines and skill-based games, this is where excitement meets entertainment."
            />
            <Spacing lg="30" md="30" />
          </Div>
          <Div className="col-lg-4">
            <IconBox
              icon="/images/icons/service_icon_3.svg"
              title="Food Court"
              subtitle="Each stall is hand-picked to deliver hygienic, freshly prepared, and flavor-packed dishes, making it a go-to dining destination for both moviegoers and food lovers across Koraput."
            />
            <Spacing lg="30" md="30" />
          </Div>
        </Div>
      </Div>
      <Spacing lg="130" md="70" />
      {/* Start Gallery Section */}
      <GalleryStyle2 />
      {/* End Gallery Section */}

      {/* Start LogoList Section */}
      {/* <Div className="container">
        <LogoList />
      </Div> */}
      {/* End LogoList Section */}

      {/* Start Testimonial Section */}
      <section>
        <div className="cs-height_145 cs-height_lg_75" />
        <div className="container">
          <SectionHeading title="Built with heart. Backed by commitment." subtitle="share it with us" variant="cs-style1 text-center" />
          <Spacing lg="90" md="45" />
          <TestimonialSliderStyle3 />
        </div>
        <Spacing lg="150" md="80" />
      </section>
      {/* End Testimonial Section */}

      {/* Start Contact Section */}
      <Div className="container">
        <Div className="row">
          <Div className="col-lg-6">
            <SectionHeading title="Theaters show films.<br/> We create <br/>experiences." subtitle="Getting Touch" />
            <Spacing lg="55" md="30" />
            <ContactInfoWidget withIcon />
            <Spacing lg="0" md="50" />
          </Div>
          <Div className="col-lg-6">
            <Div className="cs-google_map cs-type1 cs-bg" data-src="assets/img/map_img_1.jpeg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3776.3675669677937!2d82.6978572109801!3d18.82631755968937!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3af1e5b39fef67%3A0xb66b2190dffc2614!2sMEGHRAJ%20CINEMAZ!5e0!3m2!1sen!2sin!4v1747408621335!5m2!1sen!2sin"
                allowFullScreen
                title="Google Map"
              />
            </Div>
          </Div>
        </Div>
      </Div>
      <Spacing lg="125" md="55" />
      {/* End Contact Section */}
      <Cta title="meghrajcinemaz@gmail.com" bgSrc="/images/cta_bg_2.jpeg" variant="rounded-0" />
    </>
  );
}
